import { render, staticRenderFns } from "./main.vue?vue&type=template&id=5e2104ef"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e2104ef')) {
      api.createRecord('5e2104ef', component.options)
    } else {
      api.reload('5e2104ef', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=5e2104ef", function () {
      api.rerender('5e2104ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/main.vue"
export default component.exports